import React from 'react';

interface AnalyticsDashboardProps {
  userData: any;
}

export default function AnalyticsDashboard({ userData }: AnalyticsDashboardProps) {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white mb-2">
          Análisis y Métricas
        </h1>
        <p className="text-zinc-400">
          Visualiza estadísticas y rendimiento de tus máquinas.
        </p>
      </div>

      <div className="bg-zinc-800/50 p-6 rounded-lg border border-zinc-700/50 text-center">
        <p className="text-zinc-400">
          Las visualizaciones analíticas se implementarán en la siguiente fase.
        </p>
      </div>
    </div>
  );
}
